// extracted by mini-css-extract-plugin
export default {"container":"ProductForm_container__JTEPV","darkBtn":"ProductForm_darkBtn__ffXEg","lightBtn":"ProductForm_lightBtn__jsewW","bump":"ProductForm_bump__bzrUP"};